import { breadcrumbSlot } from "@redotech/arbiter/breadcrumb";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import {
  TranslatedBreadcrumbLabel,
  TranslatedBreadcrumbLayout,
} from "../return/returns-breadcrumb-label";
import { RecordViewTabsGate } from "../return/view-tabs/record-view-tabs-gate";

const registrationsListBreadcrumb = breadcrumbSlot();
const registrationBreadcrumb = breadcrumbSlot();
const createRegistrationBreadcrumb = breadcrumbSlot();

export const registrationRoutes: PermissionedRouteObject[] = [
  {
    element: (
      <>
        <TranslatedBreadcrumbLayout
          breadcrumb={registrationsListBreadcrumb}
          getLabel={(t) => t("Registrations")}
        />
        <RecordViewTabsGate type="warranties" />
      </>
    ),
    handle: { breadcrumb: registrationsListBreadcrumb },
    children: [
      {
        index: true,
        async lazy() {
          const { Registrations } = await import("./registrations");
          return { element: <Registrations /> };
        },
      },
      {
        path: ":registrationId",
        handle: { breadcrumb: registrationBreadcrumb },
        async lazy() {
          const { RegistrationPage } = await import("./registration");
          return {
            element: <RegistrationPage breadcrumb={registrationBreadcrumb} />,
          };
        },
      },
      {
        handle: { breadcrumb: createRegistrationBreadcrumb },
        path: "create-registration",
        async lazy() {
          const { CreateRegistrationPage } =
            await import("./create-registration");
          return {
            element: (
              <>
                <TranslatedBreadcrumbLabel
                  breadcrumb={createRegistrationBreadcrumb}
                  getLabel={(t) => t("Create registration")}
                />
                <CreateRegistrationPage
                  breadcrumb={createRegistrationBreadcrumb}
                />
              </>
            ),
          };
        },
      },
    ],
  },
];
